import { CART_VIEWS } from 'state/constants';

const initialState = {
  ajaxCart: {
    isOpen: false,
    data: null,
    itemsBeingAdded: {},
    itemsBeingUpdated: {},
    itemsBeingRemoved: {},
    isBeingInitialized: false,
    isSettingGiftingOptions: false,
    isBeingCleared: false,
    view: CART_VIEWS.OVERVIEW,
    errorMessage: null,
    message: null,
    returnsInsuranceRendered: false,
    upsells: {
      data: {},
      isBeingFetched: false,
    },
  },
  collection: {
    customCollection: {},
    products: {},
    storyCards: {},
    masterProducts: {},
  },
  collectionPage: {
    handle: null,
    type: null,
    isFilterDrawerOpen: false,
    filters: {},
  },
  upsells: { data: null, isBeingFetched: false },
  pdp: {
    masterProduct: null,
    products: null,
    currentProduct: null,
    initialProduct: null,
    currentOpenAttributeIndex: null,
    currentSize: null,
    currentMainCarouselSlide: 0,
    currentThumbnailCarouselSlide: 0,
    modules: {},
    selectedQuantity: 1,
    videoModalUrl: null,
  },
  personalizations: {},
  app: {
    modal: null,
    modalSignUpPurpose: null,
  },
  mailing: {
    signingUpForProductUpdates: {},
    signedUpForProductUpdates: {},
    signingUpForNewsletter: false,
    signedUpForNewsletter: false,
    errorMessage: null,
  },
  experiments: {
    addToCartModalEnabled: {},
    pdpUnisexToggle: {},
    showAfterpayAboveReviewsStars: {},
    incentivizedSignupModal: {},
    miniNavigation: {},
  },
  geofencing: {
    suggestAlternativeShop: false,
    inferredUserCountry: null,
    userSelectedShopID: null,
    alternativeShopID: null,
  },
  topNavigation: {
    currentNodeId: null,
    nodesById: null,
    nodeTree: null,
    isSearchQuickResultsOpen: false,
  },
  catalog: {
    colorways: {},
    masterProducts: {},
    parentCollections: {},
  },
  cookieConsent: {
    initialGroups: null,
  },
  shop: {
    paymentSettings: {
      supportedDigitalWallets: [],
      isPaymentSettingBegin: false,
      errorMessage: null,
    },
  },
  storeLocation: {
    storesContentByHandle: {},
    isStoreLocationContentBegin: false,
    errorMessage: null,
  },
};

export default initialState;
